module.exports = "<div class=\"formly-table\">\n  <span class=\"formly-text\">{{ 'inLast' | translate }}&nbsp;</span>\n  <input class=\"form-control\" ng-model=\"model[options.key]\">\n  <span class=\"formly-text\">&nbsp;{{ 'days' | translate }}</span>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/inLastDaysInput.html
 ** module id = 534
 ** module chunks = 0
 **/